import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgEmblemTwitter = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Twitter</title>
    <path
      d="M19.953 7.92c.012.177.012.353.012.53 0 5.423-4.128 11.676-11.675 11.676v-.004A11.615 11.615 0 0 1 2 18.284a8.24 8.24 0 0 0 6.073-1.7 4.108 4.108 0 0 1-3.834-2.85 4.09 4.09 0 0 0 1.853-.07A4.104 4.104 0 0 1 2.8 9.64v-.052c.57.318 1.21.494 1.863.514a4.108 4.108 0 0 1-1.27-5.479 11.646 11.646 0 0 0 8.456 4.287 4.108 4.108 0 0 1 6.992-3.742 8.234 8.234 0 0 0 2.607-.997 4.118 4.118 0 0 1-1.804 2.27A8.16 8.16 0 0 0 22 5.795a8.337 8.337 0 0 1-2.047 2.125Z"
      fill="#2F3639"
    />
  </svg>
);
export default SvgEmblemTwitter;
